"use strict";
/**
 * @module indicative-rules
 */
Object.defineProperty(exports, "__esModule", { value: true });
const indicative_utils_1 = require("indicative-utils");
/**
 * Removes whitespace from both sides of a given string.
 *
 * ```ts
 * import { sanitizations } from 'indicative/sanitizer'
 *
 * const sanitizationRules = {
 *   username: 'trim'
 * }
 *
 * // or
 * const sanitizationRules = {
 *   username: [
 *     sanitizations.trim()
 *   ]
 * }
 * ```
 */
const trim = {
    sanitize(data, field) {
        let fieldValue = indicative_utils_1.getValue(data, field);
        if (typeof (fieldValue) !== 'string') {
            return;
        }
        indicative_utils_1.patchValue(data, field, fieldValue.trim());
    },
};
exports.default = trim;
